import apiClient from './apiClient';

const LEAVE_TYPE_API = '/leave-types';

export const leaveTypeService = {
  /**
   * Get all leave types for current organization
   */
  getAll: async () => {
    try {
      const response = await apiClient.get(LEAVE_TYPE_API);
      return response.data;
    } catch (error) {
      console.error('Error fetching leave types:', error);
      throw error;
    }
  },

  /**
   * Get leave type by ID
   */
  getById: async (id) => {
    try {
      const response = await apiClient.get(`${LEAVE_TYPE_API}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching leave type:', error);
      throw error;
    }
  },

  /**
   * Get active leave types for organization (for dropdowns)
   */
  getOrgLeaveTypes: async () => {
    try {
      const response = await apiClient.get(`${LEAVE_TYPE_API}/org/active`);
      return response.data;
    } catch (error) {
      console.error('Error fetching organization leave types:', error);
      throw error;
    }
  },

  /**
   * Create new leave type
   */
  create: async (leaveTypeData) => {
    try {
      const response = await apiClient.post(LEAVE_TYPE_API, leaveTypeData);
      return response.data;
    } catch (error) {
      console.error('Error creating leave type:', error);
      throw error;
    }
  },

  /**
   * Update leave type
   */
  update: async (id, leaveTypeData) => {
    try {
      const response = await apiClient.put(`${LEAVE_TYPE_API}/${id}`, leaveTypeData);
      return response.data;
    } catch (error) {
      console.error('Error updating leave type:', error);
      throw error;
    }
  },

  /**
   * Delete leave type
   */
  delete: async (id) => {
    try {
      const response = await apiClient.delete(`${LEAVE_TYPE_API}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting leave type:', error);
      throw error;
    }
  }
};

export default leaveTypeService;
